import { Box, CircularProgress, Paper, Tab, Tabs } from '@mui/material'
import { Page } from 'Common/Page/Page'
import { useState } from 'react'
import { Button, PageHeader, TabPanel } from 'Common/Supplyvue-ui'
import { InventoryStockPolicyView } from './InventoryStockPolicy.view'
import { ProductionCapacityView } from './ProductionCapacity.view'
import { useGetSORStatus, useUpdateMasterData } from './SystemOfRecords.data'
import { useBreadcrumbsData } from 'Common/Breadcrumbs/Breadcrumbs.data'
// import { BaseSKUDateTab } from './Tabs/BaseSKUDateTab.view'
// import { BaseWcSKUDateTab } from './Tabs/BaseWcSKUDateTab.view'
// import { BaseSiteSKUDateTab } from './Tabs/BaseSiteSKUDateTab.view'
// import { BaseWcDateTab } from './Tabs/BaseWcDateTab.view'
// import { SkuTemplateTab } from './Tabs/SkuTemplateTab.view'

const TABS = {
  INVENTORY_TAB: 'tab-0',
  PRODUCTION_TAB: 'tab-1',
  BASE_SKU_DATE_TAB: 'tab-2',
  BASE_WC_SKU_DATE_TAB: 'tab-3',
  BASE_SITE_SKU_DATE_TAB: 'tab-4',
  BASE_WC_DATE_TAB: 'tab-5',
  SKU_TEMPLATE_TAB: 'tab-6',
}

export const SystemOfRecordsPage = () => {
  useBreadcrumbsData({
    plan_id: '',
  })
  const [selectedTab, setSelectedTab] = useState(TABS.INVENTORY_TAB)
  const { mutate: updateMasterData, isLoading: isUpdatingMasterData } =
    useUpdateMasterData()

  const { data: sorStatus } = useGetSORStatus()
  return (
    <Page>
      <Box display="flex" flexDirection="column" flex={1}>
        <PageHeader
          title="Policy settings"
          rightElement={
            <Box>
              <Button
                label="Save"
                variant="contained"
                onClick={() => {
                  updateMasterData()
                }}
                disabled={!sorStatus || sorStatus?.status === 'True'}
              >
                {isUpdatingMasterData && (
                  <CircularProgress
                    color="inherit"
                    size={16}
                    sx={{ marginRight: '8px' }}
                  />
                )}
                Update master data
              </Button>
            </Box>
          }
        />
        <Box>
          <Paper>
            <Tabs
              value={selectedTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={(_event, newValue) => setSelectedTab(newValue)}
            >
              <Tab label="Inventory" value={TABS.INVENTORY_TAB} />
              <Tab label="Production" value={TABS.PRODUCTION_TAB} />
              {/* <Tab label="Base SKU Date" value={TABS.BASE_SKU_DATE_TAB} />
              <Tab label="Base WC SKU Date" value={TABS.BASE_WC_SKU_DATE_TAB} />
              <Tab
                label="Base Site SKU Date"
                value={TABS.BASE_SITE_SKU_DATE_TAB}
              />
              <Tab label="Base WC Date" value={TABS.BASE_WC_DATE_TAB} />
              <Tab label="SKU Template" value={TABS.SKU_TEMPLATE_TAB} /> */}
            </Tabs>
          </Paper>
        </Box>
        <Box>
          <TabPanel value={selectedTab} index={TABS.INVENTORY_TAB}>
            <InventoryStockPolicyView />
          </TabPanel>
          <TabPanel value={selectedTab} index={TABS.PRODUCTION_TAB}>
            <ProductionCapacityView />
          </TabPanel>
          {/* <TabPanel value={selectedTab} index={TABS.BASE_SKU_DATE_TAB}>
            <BaseSKUDateTab />
          </TabPanel>
          <TabPanel value={selectedTab} index={TABS.BASE_WC_SKU_DATE_TAB}>
            <BaseWcSKUDateTab />
          </TabPanel>
          <TabPanel value={selectedTab} index={TABS.BASE_SITE_SKU_DATE_TAB}>
            <BaseSiteSKUDateTab />
          </TabPanel>
          <TabPanel value={selectedTab} index={TABS.BASE_WC_DATE_TAB}>
            <BaseWcDateTab />
          </TabPanel>
          <TabPanel value={selectedTab} index={TABS.SKU_TEMPLATE_TAB}>
            <SkuTemplateTab />
          </TabPanel> */}
        </Box>
      </Box>
    </Page>
  )
}
